import { ApiService } from "../../../services/ApiService";
import {
  GET_ALL_LEAVES,
  GET_JOB_TITLES,
  GET_ROLES,
  GET_OFFICES,
  GET_EVENT_CAT,
  GET_SUBCATEGORIES,
} from "../../actionTypes";

export class systemConfigThunk {
  static getAllLeaves() {
    return async (dispatch) => {
      try {
        const response = await ApiService.get("leaves");
        if (response.data) {
          dispatch({
            type: GET_ALL_LEAVES,
            payload: response.data,
          });
          return;
        }
      } catch (err) {}
    };
  }

  static getRoles() {
    return async (dispatch) => {
      try {
        const response = await ApiService.get("roles");
        if (response.data) {
          dispatch({
            type: GET_ROLES,
            payload: response.data,
          });
          return;
        }
      } catch (err) {}
    };
  }

  static getJobTitles() {
    return async (dispatch) => {
      try {
        const response = await ApiService.get("job-titles");
        if (response.data) {
          dispatch({
            type: GET_JOB_TITLES,
            payload: response.data,
          });
          return;
        }
      } catch (err) {}
    };
  }

  static getOffices() {
    return async (dispatch) => {
      try {
        const response = await ApiService.get("job-titles/get-offices");
        if (response.data) {
          dispatch({
            type: GET_OFFICES,
            payload: response.data,
          });
          return;
        }
      } catch (err) {}
    };
  }

  static getEventCat() {
    return async (dispatch) => {
      try {
        const response = await ApiService.get("events/get-events");
        if (response.data) {
          dispatch({
            type: GET_EVENT_CAT,
            payload: response.data,
          });
          return;
        }
      } catch (err) {}
    };
  }

  static getSubcategories() {
    return async (dispatch) => {
      try {
        const response = await ApiService.get("request-categories");
        if (response.data) {
          dispatch({
            type: GET_SUBCATEGORIES,
            payload: response.data,
          });
          return;
        }
      } catch (err) {}
    };
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/systemconfiguration/systemconfig.thunk.js